import { PropsWithChildren } from 'react'

const Cell = ({ children }: PropsWithChildren) => (
  <td>
    <div>{children}</div>
  </td>
)

export default Cell
